import { useQuery, keepPreviousData } from "@tanstack/react-query";

import useSystemStore from "@store/useSystemStore";
import sourcingService from "@services/sourcing.service";
import { SOURCING_THEMES_QUERY_KEY, QUERY_CACHE_EXTRA_LONG_EXPIRATION_MS } from "@config/query";
import { RelationObjectType } from "@enums/relations.enum";
import { IThemeOption } from "@interfaces/sourcing.interface";

export function useSourcingThemes(params?: { level?: number; parent?: string; enabled?: boolean }) {
  const { isAppActive } = useSystemStore();

  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch } = useQuery({
    enabled: isAppActive && params?.enabled !== false,
    queryKey: [SOURCING_THEMES_QUERY_KEY, params?.level, params?.parent],
    queryFn: async () => {
      const searchParams = new URLSearchParams();

      if (params?.parent) {
        searchParams.append("parent", params.parent);
      }

      if (typeof params?.level === "number") {
        searchParams.append("level", String(params.level));
      }

      return await sourcingService.getSourcingThemes(searchParams);
    },
    select: (data) => {
      const results: IThemeOption[] =
        data?.results.map((theme) => ({ ...theme, object_type: RelationObjectType.THEME })) ?? [];

      return results;
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_CACHE_EXTRA_LONG_EXPIRATION_MS,
    retry: false,
  });

  return { data, error, isLoading, fetchStatus, isPlaceholderData, refetch };
}
